module.exports = __webpack_public_path__ + "static/media/webcerti.3ddae036.png";